import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const InitSalesforceIframeAuth = () => {
  const location = useLocation();
  const locationSplitted = location.pathname.split('/')
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect({
      appState: {
        returnTo: '/salesforce/iFramAuthDone',      
    },})
  }, []);


  return (
    <div className="outer">
      <div className="flex items-center flex-col justify-between w-full">
        you are getting redirected
      </div>
    </div>
  );
};
